import { render } from "./ProductsPanel.vue?vue&type=template&id=115a5127&scoped=true&ts=true"
import script from "./ProductsPanel.vue?vue&type=script&lang=ts"
export * from "./ProductsPanel.vue?vue&type=script&lang=ts"

import "./ProductsPanel.vue?vue&type=style&index=0&id=115a5127&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115a5127"]])

export default __exports__